



























































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { EquipProductCategory } from '../../modules/class/EquipProductCategory'
import RemoveTag from '@/components/Parts/RemoveTag.vue'

@Component({
  components: { RemoveTag }
})
export default class EquipCard extends Vue {
  // ------------------------------------------------------------------------------------------------
  // props
  // 表示対象となる製品
  @Prop({ required: true }) private equipProductCategory!: EquipProductCategory
}
